import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Space } from 'antd';
import Typography from 'antd/es/typography/Typography';
import { Column, Table } from 'components';
import {
  StyledTableHeader,
  StyledTableWrapper,
} from 'components/table/table.styled';
import { RoleFilterFormValuesPaginated } from 'features/role-management/components/role-filter-field/type';
import { useDeleteRole } from 'features/role-management/use-cases/delete-role';
import { usePermissions } from 'features/users';
import { useTranslation } from 'react-i18next';
import { Role } from 'types/role';
type RoleTableProps = {
  roleList: Role[];
  isRoleListLoading: boolean;
  tableParams: RoleFilterFormValuesPaginated;
  setEditRoleModal: any;
  setEditRoleData: any;
};

export const RoleItemView = ({
  roleList,
  isRoleListLoading,
  tableParams,
  setEditRoleModal,
  setEditRoleData,
}: RoleTableProps) => {
  const { t } = useTranslation();
  const permissions = usePermissions();
  const { mutate } = useDeleteRole();
  if (!permissions) return null;

  const handleOpenModal = (record: any) => {
    setEditRoleModal(true);
    setEditRoleData(record);
  };
  const onChangeDelete = (data: any) => {
    mutate(data.Id); // Call mutate with data.id
  };

  return (
    <StyledTableWrapper>
      <StyledTableHeader></StyledTableHeader>
      <Table<Role>
        loading={isRoleListLoading}
        dataSource={roleList}
        rowKey='id'
        // onChange={handleTableChange}
        pagination={{
          current: tableParams.PageIndex,
          defaultPageSize: tableParams.RecordPerPage,
          total: 10,
        }}
        components={{
          header: {
            cell: (props: React.HTMLAttributes<HTMLTableHeaderCellElement>) => (
              <th {...props} />
            ),
          },
        }}
      >
        <Column<Role> title={'Name'} dataIndex={'RoleName'} />
        <Column<Role>
          title={t('usermanagement.table.status')}
          dataIndex={'role'}
          render={(_, record: any) => (
            <Space>
              <Typography
                style={{
                  color: record.IsActive == true ? '#155724' : 'red', // Green for "Active", Red for "Inactive"
                }}
              >
                {record.IsActive == true ? 'Active' : 'Inactive'}
              </Typography>
            </Space>
          )}
        />
        <Column<Role>
          title={t('usermanagement.table.action')}
          dataIndex={'Id'}
          render={(_, record: any) => (
            <Space>
              <Button onClick={() => handleOpenModal(record)}>
                <EditOutlined />
              </Button>
              <Popconfirm
                title='Delete the Role'
                description='Are you sure to delete this Role?'
                onConfirm={() => onChangeDelete(record)}
                okText='Yes'
                cancelText='No'
              >
                <Button color='danger'>
                  <DeleteOutlined />
                </Button>
              </Popconfirm>
            </Space>
          )}
        />
      </Table>
    </StyledTableWrapper>
  );
};
